import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed top-12 left-0 right-0 h-12 bg-neutral-100 z-40 border-b border-slate-400 p-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "h-7 ml-2" }, "thread name:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "h-7 ml-2" }, "stack trace:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "h-7 ml-2" }, "&& !", -1)
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "fixed top-24 left-0 right-0 h-8 bg-neutral-50 z-40 border-b border-slate-400 p-0.5" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  id: "time-label",
  class: "text-xs relative hidden",
  style: {"transform":"translateX(-100%)"}
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "absolute top-20 right-0 left-0 bottom-0" }
const _hoisted_13 = { class: "w-full h-full" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "w-full h-full" }
const _hoisted_18 = { class: "p-2" }
const _hoisted_19 = { class: "h-full p-2 overflow-auto" }
const _hoisted_20 = { class: "table-auto whitespace-nowrap" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { class: "text-right" }, "timestamp :", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", { class: "text-right" }, "os thread id :", -1)
const _hoisted_23 = {
  key: 0,
  class: "fixed w-72 h-24 bg-neutral-200 border-neutral-500 p-2 border-2 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
}
const _hoisted_24 = {
  key: 1,
  class: "fixed w-72 h-24 bg-neutral-200 border-neutral-500 p-2 border-2 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
}

import { Splitpanes, Pane } from "splitpanes";
import {
  Renderer,
  ChartConfig, ExecutionSampleInfo,
} from "../../jfrv-wasm/pkg";
import {ComponentPublicInstance, onMounted, onUnmounted, ref} from "vue";
import {FileRejectReason, useDropzone} from "vue3-dropzone";
import 'splitpanes/dist/splitpanes.css';
import TabView from "@/components/TabView.vue";
import {FLAME_GRAPH_CONFIG, FlameGraphWindow} from "@/views/flame-graph";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExecutionSample',
  setup(__props) {

const CHART_CONFIG: ChartConfig = {
  defaultMargin: 1,
  fontSize: 14, // 0.875rem
  headerConfig: {
    borderWidth: 1,
    borderColorRgbHex: 0x707070,
    elementId: "header",
    paneId: "header-pane",
    overlayElementId: "header-overlay"
  },
  sampleViewConfig: {
    elementId: "thread-chart-sample-view",
    paneId: "chart-pane",
    overlayElementId: "chart-overlay",
    sampleRenderSize: {
      width: 6,
      height: 8
    },
    backgroundRgbHex: 0xf5f5f5
  },
  threadStateColorConfig: {
    stateRunnableRgbHex: 0x6cba1e,
    stateSleepingRgbHex: 0x8554c2,
    stateUnknownRgbHex: 0x6f6d72,
    stateHiddenRgbHex: 0xc4c4c4,
  },
  overlayConfig: {
    rowHighlightArgbHex: 0x40404040,
    sampleHighlightRgbHex: 0xf04074,
    timestampStrokeWidth: 0.5,
  },
  axisConfig: {
    labelElementId: "time-label",
  }
}

const renderer = ref<Renderer>()

const highlightedSample = ref<ExecutionSampleInfo>()
const headerPane = ref<ComponentPublicInstance>()
const chartPane = ref<ComponentPublicInstance>()
const headerOverlay = ref<HTMLCanvasElement>()
const chartOverlay = ref<HTMLCanvasElement>()
const header = ref<SVGGraphicsElement>()
const chart = ref<HTMLCanvasElement>()
const timeAxis = ref<HTMLElement>()
const threadNameRegex = ref<string>()
const stackTraceMatchRegex = ref<string>()
const stackTraceRejectRegex = ref<string>()
const state = ref<"loading" | "loaded" | "failed">()
const currentFailure = ref<string>()
const currentScale = ref<number>()

const {
  getRootProps,
  getInputProps,
  isDragActive,
  open
} = useDropzone({
  onDrop: openFile,
  multiple: false,
  noClick: true,
  noKeyboard: true,
  accept: [".jfr", ".gz"],
})

onMounted(async () => {
  const wasm = await import("../../jfrv-wasm/pkg")
  renderer.value = new wasm.Renderer(CHART_CONFIG)
  currentScale.value = 1;
  window.addEventListener('resize', syncSize);
})

onUnmounted(() => {
  window.removeEventListener('resize', syncSize);
})

function nullIfEmpty(value: string | undefined): string | null {
  if (value !== undefined && value?.length > 0) {
    return value;
  }
  return null;
}

function onFilterChange() {
  if (!state.value) {
    return
  }

  renderer.value?.apply_filter({
    threadNameRegex: nullIfEmpty(threadNameRegex.value),
    stackTraceMatchRegex: nullIfEmpty(stackTraceMatchRegex.value),
    stackTraceRejectRegex: nullIfEmpty(stackTraceRejectRegex.value),
  })
}

function onChartClick() {
  highlightedSample.value = renderer.value?.on_chart_click()
}

function onHeaderMouseMove(e: MouseEvent) {
  renderer.value?.on_header_mouse_move(
      e.clientX - header.value!.getBoundingClientRect().x,
      e.clientY - header.value!.getBoundingClientRect().y)
}

function onChartMouseMove(e: MouseEvent) {
  renderer.value?.on_chart_mouse_move(
      e.clientX - chart.value!.getBoundingClientRect().x,
      e.clientY - chart.value!.getBoundingClientRect().y)
}

function onMouseOut() {
  renderer.value?.on_mouse_out()
}

async function openFile(acceptedFiles: File[], rejectReasons: FileRejectReason[]) {
  state.value = "loading"
  const file = acceptedFiles[0]
  const buf = await file.arrayBuffer()
  const data = new Uint8Array(buf)

  await loadData(file.name, data)
}

async function loadDemo() {
  state.value = "loading"
  const response = await fetch(`${process.env.BASE_URL}demo.jfr`)
  const buf = await response.arrayBuffer()
  const data = new Uint8Array(buf)

  await loadData("demo.jfr", data)
}

async function onScaleChange(scale: number) {
  let newWidth = CHART_CONFIG.sampleViewConfig.sampleRenderSize.width * scale

  const maxWidth = CHART_CONFIG.sampleViewConfig.sampleRenderSize.width * 8
  const minWidth = 1

  if (newWidth < minWidth || newWidth > maxWidth) {
    return
  }
  currentScale.value = scale
  await renderer.value?.change_scale(newWidth)
}

async function showFlameGraph() {
  const flameGraph = await renderer.value?.flame_graph(FLAME_GRAPH_CONFIG);
  if (!flameGraph) {
    return
  }

  FlameGraphWindow.open(flameGraph)
}

async function loadData(filename: string, data: Uint8Array) {
  threadNameRegex.value = undefined;
  stackTraceMatchRegex.value = undefined;
  stackTraceRejectRegex.value = undefined;
  try {
    const encoding = filename.endsWith(".gz") ? "Gzip" : "Uncompressed"
    renderer.value?.initialize(data, encoding)
    renderer.value?.render()
    syncSize()
  } catch (e: any) {
    state.value = "failed"
    currentFailure.value = e?.toString()
    throw e
  }

  document.title = `jfrv - ${filename}`
  state.value = "loaded"
}

const syncScroll = (src: "header" | "chart") => {
  const header = headerPane.value?.$el
  const chart = chartPane.value?.$el

  if (src === "header") {
    chart.scrollTop = header.scrollTop
  }
  if (src === "chart") {
    header.scrollTop = chart.scrollTop
  }
}

const syncSize = () => {
  const header = headerOverlay.value
  const chart = chartOverlay.value
  const time = timeAxis.value
  if (!(header && chart && time)) {
    return
  }

  header.width = headerPane.value?.$el.getBoundingClientRect().width
  header.height = headerPane.value?.$el.getBoundingClientRect().height
  header.style.left = `${headerPane.value?.$el.getBoundingClientRect().left}px`
  header.style.top = `${headerPane.value?.$el.getBoundingClientRect().top}px`

  chart.width = chartPane.value?.$el.getBoundingClientRect().width
  chart.height = chartPane.value?.$el.getBoundingClientRect().height
  chart.style.left = `${chartPane.value?.$el.getBoundingClientRect().left}px`
  chart.style.top = `${chartPane.value?.$el.getBoundingClientRect().top}px`

  time.style.width = `${chart.width}px`
  time.style.left = chart.style.left
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TabView, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "hover:bg-slate-300 w-24 h-7 text-sm text-center border-2 rounded border-slate-400",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(open) && _unref(open)(...args)))
        }, "open file"),
        _createElementVNode("button", {
          class: "hover:bg-slate-300 w-24 h-7 text-sm text-center border-2 border-slate-500 absolute right-2",
          onClick: loadDemo
        }, "load demo"),
        _hoisted_2,
        _withDirectives(_createElementVNode("input", {
          class: "h-7",
          type: "text",
          placeholder: "regex",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((threadNameRegex).value = $event)),
          onChange: onFilterChange
        }, null, 544), [
          [_vModelText, threadNameRegex.value]
        ]),
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          class: "h-7",
          type: "text",
          placeholder: "match regex",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((stackTraceMatchRegex).value = $event)),
          onChange: onFilterChange
        }, null, 544), [
          [_vModelText, stackTraceMatchRegex.value]
        ]),
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          class: "h-7",
          type: "text",
          placeholder: "reject regex",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((stackTraceRejectRegex).value = $event)),
          onChange: onFilterChange
        }, null, 544), [
          [_vModelText, stackTraceRejectRegex.value]
        ]),
        _createElementVNode("input", _normalizeProps(_guardReactiveProps(_unref(getInputProps)())), null, 16),
        _createElementVNode("button", {
          class: "disabled:opacity-50 enabled:hover:bg-slate-300 w-8 h-7 ml-2 text-sm text-center border-2 rounded border-slate-400",
          onClick: showFlameGraph,
          disabled: state.value !== 'loaded'
        }, "🔥", 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "disabled:opacity-50 enabled:hover:bg-slate-300 w-12 h-5 ml-2 text-xs text-center border-2 border-slate-400",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (onScaleChange(1))),
          disabled: state.value !== 'loaded'
        }, "reset", 8, _hoisted_7),
        _createElementVNode("button", {
          class: "disabled:opacity-50 enabled:hover:bg-slate-300 w-5 h-5 ml-2 text-xs text-center border-2 border-slate-400",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (onScaleChange(currentScale.value / 1.5))),
          disabled: state.value !== 'loaded'
        }, "-", 8, _hoisted_8),
        _createElementVNode("button", {
          class: "disabled:opacity-50 enabled:hover:bg-slate-300 w-5 h-5 ml-2 text-xs text-center border-2 border-slate-400",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (onScaleChange(currentScale.value * 1.5))),
          disabled: state.value !== 'loaded'
        }, "+", 8, _hoisted_9),
        _createElementVNode("div", {
          ref_key: "timeAxis",
          ref: timeAxis,
          id: "time-axis",
          class: "absolute z-10 top-0 h-full"
        }, _hoisted_11, 512)
      ]),
      _createElementVNode("canvas", {
        ref_key: "headerOverlay",
        ref: headerOverlay,
        id: "header-overlay",
        class: "fixed pointer-events-none z-10",
        width: "0",
        height: "0"
      }, null, 512),
      _createElementVNode("canvas", {
        ref_key: "chartOverlay",
        ref: chartOverlay,
        id: "chart-overlay",
        class: "fixed pointer-events-none z-10",
        width: "0",
        height: "0"
      }, null, 512),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_unref(Splitpanes), _mergeProps({
          class: "default-theme text-sm",
          horizontal: ""
        }, _unref(getRootProps)(), {
          onResize: _cache[10] || (_cache[10] = ($event: any) => (syncSize()))
        }), {
          default: _withCtx(() => [
            _createVNode(_unref(Pane), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_unref(Splitpanes), {
                    vertical: "",
                    onResize: _cache[9] || (_cache[9] = ($event: any) => (syncSize()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Pane), {
                        size: "25",
                        class: "overflow-x-hidden overflow-y-auto scrollbar-none relative",
                        onScroll: _cache[7] || (_cache[7] = ($event: any) => (syncScroll('header'))),
                        ref_key: "headerPane",
                        ref: headerPane,
                        id: "header-pane"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock("svg", {
                            ref_key: "header",
                            ref: header,
                            id: "header",
                            class: "absolute top-0 left-0",
                            onMousemove: onHeaderMouseMove,
                            onMouseout: onMouseOut,
                            width: "0",
                            height: "0"
                          }, null, 544))
                        ]),
                        _: 1
                      }, 512),
                      _createVNode(_unref(Pane), {
                        class: "overflow-auto relative",
                        onScroll: _cache[8] || (_cache[8] = ($event: any) => (syncScroll('chart'))),
                        ref_key: "chartPane",
                        ref: chartPane,
                        id: "chart-pane"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("canvas", {
                            ref_key: "chart",
                            ref: chart,
                            id: "thread-chart-sample-view",
                            onMousemove: onChartMouseMove,
                            onMouseout: onMouseOut,
                            onClick: onChartClick,
                            class: "bg-slate-100",
                            width: "0",
                            height: "0"
                          }, null, 544),
                          (!state.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                (_unref(isDragActive))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Drop here ..."))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_16, "Drag & drop OR press \"open file\" to select JFR file"))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Pane), {
              size: "40",
              class: "overflow-auto"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_unref(Splitpanes), { vertical: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Pane), {
                        size: "75",
                        class: "overflow-auto"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_18, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(highlightedSample.value?.stackTrace.frames, (frame, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "flex flex-col space-x-2 text-sm",
                                key: idx
                              }, _toDisplayString(frame.name), 1))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Pane), null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("table", _hoisted_20, [
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                  _hoisted_21,
                                  _createElementVNode("td", null, _toDisplayString(highlightedSample.value?.timestamp), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _hoisted_22,
                                  _createElementVNode("td", null, _toDisplayString(highlightedSample.value?.osThreadId), 1)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 16)
      ]),
      (state.value === 'loading')
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Loading..."))
        : _createCommentVNode("", true),
      (state.value === 'failed')
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Failed to load JFR: " + _toDisplayString(currentFailure.value), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})